"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.match.js");

var Is = {
  /**
   * @function Is[Function] - 判断是否函数类型或系统
   * @param {function} obj 函数
   * @return {boolean} true/false
   * @example
   * import { Is } from '@zz-biz/utils';
   * 
   * const test = () => {
   *   console.log('这是一个函数');
   * };
   * 
   * Is.Function(test);
   * 
   * // return true
   */
  Function: function Function(obj) {
    return typeof obj === "function" && typeof obj.nodeType !== "number";
  },

  /**
   * @function Is[Array] - 判断是否数组类型
   * @param {array} obj 数组
   * @return {boolean} true/false
   * @example
   * import { Is } from '@zz-biz/utils';
   * 
   * const test = [12, 23, 3223];
   * 
   * Is.Array(test);
   * 
   * // return true
   */
  Array: function (_Array) {
    function Array(_x) {
      return _Array.apply(this, arguments);
    }

    Array.toString = function () {
      return _Array.toString();
    };

    return Array;
  }(function (obj) {
    return obj instanceof Array;
  }),

  /**
   * @function Is[Date] - 判断是否有效的date对象
   * @param {Date} date date对象
   * @return {boolean} true/false
   * @example
   * import { Is } from '@zz-biz/utils';
   * 
   * const test = new Date();
   * 
   * Is.Date(test);
   * 
   * // return true
   */
  Date: function Date(date) {
    return Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());
  },

  /**
   * @function Is[IOS] - 判断是否是ios系统
   * @return {boolean} true/false
   * @example
   * import { Is } from '@zz-biz/utils';
   * 
   * Is.IOS();
   * 
   * // return true
   */
  IOS: function IOS() {
    var userAgent = navigator.userAgent;
    return userAgent.indexOf('iPhone') > -1 || userAgent.indexOf('iPad') > -1 || userAgent.indexOf('Safari') === -1;
  },

  /**
   * @function Is[android] - 是否是安卓环境 
   * @return {boolean} true/false
   * @example
   * import { Is } from '@zz-biz/utils';
   * 
   * Is.android();
   * 
   * // return true
   */
  android: function android() {
    return /Android|Adr/.test(navigator.userAgent);
  },

  /**
   * @function Is[WeChat] - 是否是微信环境 
   * @return {boolean} true/false
   * @example
   * import { Is } from '@zz-biz/utils';
   * 
   * Is.WeChat();
   * 
   * // return true
   */
  WeChat: function WeChat() {
    return /micromessenger/i.test(navigator.userAgent) && !navigator.userAgent.match(/miniprogram/i);
  },

  /**
   * @function Is[wa] - 判断是否小程序环境
   * @return {boolean} true/false
   * @example
   * import { Is } from '@zz-biz/utils';
   * 
   * Is.wa();
   * 
   * // return true
   */
  wa: function wa() {
    return navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram';
  }
};
var _default = Is;
exports["default"] = _default;